<script setup lang="ts">
import type { GeoLocation } from '@smg-real-estate/geo-libs';
import { useI18n } from 'vue-i18n';

import Locations from '@/components/Locations/Locations.vue';
import { ValidationStates } from '@/components/Locations/validationStates';
import {
  type DirectoryLocationSearchStore,
  useLocationSearch,
} from '@/composables/useLocationSearch';
import { useLocale } from '@/router/routeMeta';

const props = defineProps<{
  store: DirectoryLocationSearchStore & { selectedLocations: GeoLocation[] };
  stripQueryKeys?: string[];
  searchSubmitHandler?: (locations: GeoLocation[]) => void;
}>();

const { t } = useI18n();
const locale = useLocale();

const { geoSearchResultList, handleSearchTextChange, handleLocationChange, applySearch } =
  useLocationSearch(props.store, {
    stripQueryKeys: props.stripQueryKeys,
    onSearchSubmit: props.searchSubmitHandler,
  });

defineExpose({ applySearch });
</script>

<template>
  <Locations
    data-dd-action-name="SearchBar Locations Input"
    :t="t"
    :locale="locale"
    :searchResults="geoSearchResultList"
    :selectedLocations="store.selectedLocations"
    :validationState="ValidationStates.Valid"
    @locationsChanged="handleLocationChange"
    @searchTextUpdated="handleSearchTextChange"
  />
</template>
